(function () {
  var DICT = {
    en: { sg: 'Guard', pl: 'Guards', phrases: {
      '60 Nächte risikofrei testen': '60-night risk-free trial',
      'Gratis Zahnabdruckset': 'Free impression kit',
      'Gratis Aufbewahrungsbox': 'Free storage case',
      'BELIEBTESTE WAHL': 'MOST POPULAR',
      'BESTER PREIS': 'BEST PRICE',
      '2 + 1 GRATIS': '2 + 1 FREE',
      '3 + 2 GRATIS': '3 + 2 FREE' } },
    fr: { sg: 'gouttière', pl: 'gouttières', phrases: {
      '60 Nächte risikofrei testen': '60 nuits d\u2019essai sans risque',
      'Gratis Zahnabdruckset': 'Kit d\u2019empreinte offert',
      'Gratis Aufbewahrungsbox': 'Bo\u00eete de rangement offerte',
      'BELIEBTESTE WAHL': 'LE PLUS POPULAIRE',
      'BESTER PREIS': 'MEILLEUR PRIX',
      '2 + 1 GRATIS': '2 + 1 OFFERTE',
      '3 + 2 GRATIS': '3 + 2 OFFERTES' } },
    nl: { sg: 'bitje', pl: 'bitjes', phrases: {
      '60 Nächte risikofrei testen': '60 nachten risicovrij proberen',
      'Gratis Zahnabdruckset': 'Gratis afdrukset',
      'Gratis Aufbewahrungsbox': 'Gratis opbergdoosje',
      'BELIEBTESTE WAHL': 'MEEST GEKOZEN',
      'BESTER PREIS': 'BESTE PRIJS' } }
  };

  var m = window.location.pathname.match(/^\/(en|fr|nl)(\/|$)/);
  var d = DICT[m ? m[1] : 'de'];

  function tn(node) {
    if (!d) return;
    var t = node.nodeValue, o = t;
    for (var k in d.phrases) { if (t.indexOf(k) > -1) t = t.split(k).join(d.phrases[k]); }
    t = t.replace(/(\d+)\s+Schienen/g, '$1 ' + d.pl)
         .replace(/(\d+)\s+Schiene\b/g, '$1 ' + d.sg)
         .replace(/\/Schiene\b/g, '/' + d.sg);
    if (t !== o) node.nodeValue = t;
  }

  function parseNums(str) {
    var re = /\d[\d.,\u00A0 ]*\d|\d/g, out = [], mm;
    while ((mm = re.exec(str))) {
      var raw = mm[0].replace(/[\u00A0 ]/g, '');
      var lastDot = raw.lastIndexOf('.'), lastCom = raw.lastIndexOf(',');
      var decPos = Math.max(lastDot, lastCom), val;
      if (decPos > -1 && raw.length - decPos - 1 <= 2) {
        val = parseInt(raw.slice(0, decPos).replace(/[^\d]/g, '') || '0', 10) +
              parseInt(raw.slice(decPos + 1), 10) / Math.pow(10, raw.length - decPos - 1);
      } else {
        val = parseInt(raw.replace(/[^\d]/g, ''), 10);
      }
      out.push(val);
    }
    return out;
  }

  function currencyOf(str) {
    var mm = str.match(/(€|\$|£|kr\.?|CHF|z\u0142)/i);
    if (!mm) return { sym: '\u20AC', after: false };
    var idxNum = str.search(/\d/);
    return { sym: mm[0], after: str.indexOf(mm[0]) > idxNum };
  }

  function fmt(val, sample) {
    var dec = ',';
    var dm = sample.match(/\d([.,])\d{2}(?!\d)/);
    if (dm) dec = dm[1];
    var thou = dec === ',' ? '.' : ',';
    var s = val.toFixed(2).split('.');
    var ip = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return ip + dec + s[1];
  }

  function unitWord() { return d ? d.sg : 'Schiene'; }

  function fixUnits(root) {
    var boxes = root.querySelectorAll('.bundle-option-box');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var title = box.querySelector('.title');
      var sub = box.querySelector('.subtitle');
      var price = box.querySelector('.price');
      if (!title || !sub || !price) continue;
      var qm = (title.textContent || '').match(/(\d+)/);
      if (!qm) continue;
      var qty = parseInt(qm[1], 10);

      var clone = price.cloneNode(true);
      var inner = clone.querySelectorAll('.subtitle');
      for (var j = 0; j < inner.length; j++) inner[j].parentNode.removeChild(inner[j]);
      var ptext = clone.textContent || '';

      var nums = parseNums(ptext);
      if (!qty || !nums.length) continue;

      var mx = Math.max.apply(null, nums);
      var totals = [];
      for (var k2 = 0; k2 < nums.length; k2++) { if (nums[k2] >= mx / 2) totals.push(nums[k2]); }
      var total = Math.min.apply(null, totals);

      var cur = currencyOf(ptext);
      var unit = fmt(total / qty, ptext);
      var txt = (cur.after ? unit + ' ' + cur.sym : cur.sym + unit) + '/' + unitWord();
      if (sub.textContent !== txt) sub.textContent = txt;
    }
  }

  function observeRoot(sr) {
    if (sr.__daObs) return;
    sr.__daObs = true;
    new MutationObserver(function () { walk(sr); })
      .observe(sr, { childList: true, subtree: true, characterData: true });
  }

  function walk(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n; while ((n = w.nextNode())) tn(n);
    if (root.querySelectorAll) fixUnits(root);
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) { observeRoot(els[i].shadowRoot); walk(els[i].shadowRoot); }
      if (els[i].tagName === 'IFRAME') { try { if (els[i].contentDocument) walk(els[i].contentDocument.body); } catch (e) {} }
    }
  }

  function run() { try { walk(document.body); } catch (e) {} }

  run();
  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true, characterData: true });
  setInterval(run, 800);
})();